import moment from "moment";
import { BASENAME } from "../router/constants";

import { DateToStoryblokQueryableDateString } from "./dateHelper";
import { LANGUAGES_BY_BASENAME } from "../constants/languages";

function ArticleStoryToObject(story) {
  let s = {
    uuid: story.uuid,
    lang: GetStoryLanguage(story),
    name: story.name,
    full_slug: story.full_slug,
    slug: story.slug,
    tag_list: story.tag_list,
    alternates: story.alternates,

    ...story.content,
    has_comments: story.content.has_comments !== "no",
    has_social_sharing: story.content.has_social_sharing !== "no",
  };
  if (s.authors && s.authors.length > 0 && typeof s.authors[0] !== "string") {
    s.authors = story.content.authors.map((a) => {
      return AuthorStoryToObject(a);
    });
  }
  return s;
}

function ArticleTypeStoryToObject(story) {
  return GeneralStoryToObject(story);
}

function AuthorStoryToObject(story) {
  return GeneralStoryToObject(story);
}

function ArticleCategoryStoryToObject(story) {
  return GeneralStoryToObject(story);
}

function GlobalSettingsStoryToObject(story) {
  return GeneralStoryToObject(story);
}

function ProductStoryToObject(story) {
  return GeneralStoryToObject(story);
}

function TagResultsTemplateStoryToObject(story) {
  return GeneralStoryToObject(story);
}

function SearchResultsTemplateStoryToObject(story) {
  return GeneralStoryToObject(story);
}

function SeriesStoryToObject(story) {
  return GeneralStoryToObject(story);
}

function BannerStoryToObject(story) {
  return GeneralStoryToObject(story);
}

function GeneralStoryToObject(story) {
  return {
    uuid: story.uuid,
    lang: GetStoryLanguage(story),
    name: story.name,
    full_slug: story.full_slug,
    slug: story.slug,
    tag_list: story.tag_list,
    alternates: story.alternates,

    ...story.content,
  };
}

function GetStoryLanguage(story) {
  if (story) {
    const slug = story.full_slug || story.slug;
    let folderTranslation = slug.substring(0, slug.indexOf("/"));

    if (folderTranslation.length !== 2) {
      folderTranslation = "";
    }

    if (!folderTranslation) {
      // Look at url?
      if (typeof window !== undefined) {
        let path = window.location.pathname;
        if (path.startsWith(`/${BASENAME}`)) {
          folderTranslation = "en";
        } else if (path.startsWith("/global-settings")) {
          folderTranslation = "en";
        } else {
          const parts = path.split("/").filter((p) => {
            return p ? true : false;
          });
          if (parts[0] && parts[0].length === 2) {
            folderTranslation = parts[0];
          }
        }
      }
    }

    return folderTranslation || (story.lang === "default" ? "en" : story.lang);
  }
  return null;
}

function GetWindowLanguage() {
  let path = window.location.pathname;
  let locale = path.substring(1).split('/').shift()
  if (locale in LANGUAGES_BY_BASENAME) return locale
  return 'en'
} 

// needs a list of stories and a moment date
function FilterStoriesPastPublishOffDate(stories, mDate) {
  return stories.filter((s) => {
    let publishOff = s.content.publish_off;
    if (publishOff) {
      let mStoryDate = moment.utc(publishOff);
      if (mDate.isAfter(mStoryDate)) {
        return false;
      }
    }
    return true;
  });
}
// Needs a moment date object
function GetFilterQueryForPublishOn(mDate) {
  return {
    publish_on: { lt_date: DateToStoryblokQueryableDateString(mDate) },
  };
}
// sorts a list of article story objects
function SortArticlesByMostRecent(a, b) {
  if (a.article_date) {
    if (b.article_date) {
      return moment.utc(a.article_date).isBefore(moment.utc(b.article_date))
        ? 1
        : -1;
    }
    return -1;
  } else if (b.article_date) {
    return 1;
  } else {
    return 0;
  }
}

export {
  GetWindowLanguage,
  GetStoryLanguage,
  FilterStoriesPastPublishOffDate,
  GetFilterQueryForPublishOn,
  SortArticlesByMostRecent,
  ArticleStoryToObject,
  ArticleTypeStoryToObject,
  AuthorStoryToObject,
  ArticleCategoryStoryToObject,
  GlobalSettingsStoryToObject,
  ProductStoryToObject,
  SeriesStoryToObject,
  TagResultsTemplateStoryToObject,
  SearchResultsTemplateStoryToObject,
  BannerStoryToObject,
};
